// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    const productModule = await import('./pages/product/ProductContainer');
    Components.ProductContainer = productModule.ProductContainer;

    const collectionModule = await import('./pages/collection/CollectionContainer');
    Components.CollectionContainer = collectionModule.CollectionContainer;
    Components.CollectionContainerMobile = collectionModule.CollectionContainerMobile;

    const homeModule = await import('./pages/Home');
    Components.Home = homeModule.Home;

    const cabinetModule = await import('./pages/cabinetVisualizer/CabinetVisualizerContainer');
    Components.CabinetVisualizerContainer = cabinetModule.CabinetVisualizerContainer;

    const cabinetMobileModule = await import('./pages/cabinetVisualizer/CabinetVisualizerContainerMobile');
    Components.CabinetVisualizerContainerMobile = cabinetMobileModule.CabinetVisualizerContainerMobile;

    const sandboxModule = await import('./pages/sandbox/SandboxContainer');
    Components.SandboxContainer = sandboxModule.SandboxContainer;

    const vehicleModule = await import('./pages/vehicleStorage/VehicleStorageContainer');
    Components.VehicleStorageContainer = vehicleModule.VehicleStorageContainer;

    const vehicleMobileModule = await import('./pages/vehicleStorage/VehicleStorageContainerMobile');
    Components.VehicleStorageContainerMobile = vehicleMobileModule.VehicleStorageContainerMobile;

    const wallModule = await import('./pages/wallStorage/WallStorageContainer');
    Components.WallStorageContainer = wallModule.WallStorageContainer;

    const wallMobileModule = await import('./pages/wallStorage/WallStorageContainerMobile');
    Components.WallStorageContainerMobile = wallMobileModule.WallStorageContainerMobile;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, channel, serverPages) => ({
  product: {
    name: 'ProductContainer',
    componentName: 'ProductContainer',
    chunk: () => import(
      './pages/product/ProductContainer'
    ),
    get component() {
      return ssr
        ? serverPages.ProductContainer
        : currentRouteName === 'ProductContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })));
    },
    // https://www.homedepot.com/p/Some-Product-Name/123456789
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse'],
    channel
  },
  collection: {
    name: 'CollectionContainer',
    componentName: 'CollectionContainer',
    chunk: () => import(
      './pages/collection/CollectionContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CollectionContainer
        : currentRouteName === 'CollectionContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CollectionContainer })));
    },
    // https://www.homedepot.com/p/cabinet-seller/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-seller/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  collectionMobile: {
    name: 'CollectionContainerMobile',
    componentName: 'CollectionContainerMobile',
    chunk: () => import(
      './pages/collection/CollectionContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CollectionContainerMobile
        : currentRouteName === 'CollectionContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.CollectionContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/cabinet-seller/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-seller/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home'
    ),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel
  },
  cabinetVisualizer: {
    name: 'CabinetVisualizerContainer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainer
        : currentRouteName === 'CabinetVisualizerContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerMobile: {
    name: 'CabinetVisualizerContainerMobile',
    componentName: 'CabinetVisualizerContainerMobile',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainerMobile
        : currentRouteName === 'CabinetVisualizerContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.CabinetVisualizerContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/:slug?/:omsId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  cabinetVisualizerDefault: {
    name: 'CabinetVisualizerContainer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainer
        : currentRouteName === 'CabinetVisualizerContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerDefaultMobile: {
    name: 'CabinetVisualizerContainerMobile',
    componentName: 'CabinetVisualizerContainerMobile',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainerMobile
        : currentRouteName === 'CabinetVisualizerContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  cabinetVisualizerSDT: {
    name: 'CabinetVisualizerContainer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainer
        : currentRouteName === 'CabinetVisualizerContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/p/cabinet-shop-your-space/designs/Kitchen Cabinets/new/:omsId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  cabinetVisualizerSDTDefault: {
    name: 'CabinetVisualizerContainer',
    componentName: 'CabinetVisualizerContainer',
    chunk: () => import(
      './pages/cabinetVisualizer/CabinetVisualizerContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.CabinetVisualizerContainer
        : currentRouteName === 'CabinetVisualizerContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.CabinetVisualizerContainer
          })));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space
    path: '/:context?/p/cabinet-shop-your-space/designs/Kitchen Cabinets/new/',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  sandbox: {
    name: 'SandboxContainer',
    componentName: 'SandboxContainer',
    chunk: () => import(
      './pages/sandbox/SandboxContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.SandboxContainer
        : currentRouteName === 'SandboxContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.SandboxContainer })
          ));
    },
    // https://www.homedepot.com/p/cabinet-shop-your-space/Some-Product-Name/123456789
    path: '/:context?/sandbox/:itemId',
    channel: 'desktop'
  },
  vehicleStorageMobile: {
    name: 'VehicleStorageContainerMobile',
    componentName: 'VehicleStorageContainerMobile',
    chunk: () => import(
      './pages/vehicleStorage/VehicleStorageContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.VehicleStorageContainerMobile
        : currentRouteName === 'VehicleStorageContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.VehicleStorageContainerMobile })
          ));
    },
    // https://www.homedepot.com/p/build-your-rack-system/milwaukee-packout-rack/123456789
    path: '/:context?/p/build-your-rack-system/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  vehicleStorage: {
    name: 'VehicleStorageContainer',
    componentName: 'VehicleStorageContainer',
    chunk: () => import(
      './pages/vehicleStorage/VehicleStorageContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.VehicleStorageContainer
        : currentRouteName === 'VehicleStorageContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.VehicleStorageContainer })
          ));
    },
    // https://www.homedepot.com/p/build-your-rack-system/milwaukee-packout-rack/123456789
    path: '/:context?/p/build-your-rack-system/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
  wallStorageMobile: {
    name: 'WallStorageContainerMobile',
    componentName: 'WallStorageContainerMobile',
    chunk: () => import(
      './pages/wallStorage/WallStorageContainerMobile'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.WallStorageContainerMobile
        : currentRouteName === 'WallStorageContainerMobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.WallStorageContainerMobile })
          ));
    },
    // Example: https://www.homedepot.com/p/build-your-wall-storage/some-wall-storage/123456789
    path: '/:context?/p/build-your-wall-storage/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'mobile'
  },
  wallStorage: {
    name: 'WallStorageContainer',
    componentName: 'WallStorageContainer',
    chunk: () => import(
      './pages/wallStorage/WallStorageContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.WallStorageContainer
        : currentRouteName === 'WallStorageContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then(
            (pageModule) => ({ default: pageModule.WallStorageContainer })
          ));
    },
    // Example: https://www.homedepot.com/p/build-your-wall-storage/some-wall-storage/123456789
    path: '/:context?/p/build-your-wall-storage/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },
});
